const GivingMoneyIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5002 38.5002H9.50024V25.5002H14.5002V29.5002M14.5002 38.5002V29.5002M14.5002 38.5002C28.0002 38.5002 38.5002 32.0002 38.5002 32.0002V27.5002H26.5002M14.5002 29.5002L21.5591 25.7355C21.8487 25.5811 22.172 25.5002 22.5002 25.5002H24.5002C25.6048 25.5002 26.5002 26.3957 26.5002 27.5002M21.5002 32.5002L26.5002 30.0002V27.5002M36.0002 20.5002H36.2502C37.4929 20.5002 38.5002 19.4929 38.5002 18.2502C38.5002 17.0076 37.4929 16.0002 36.2502 16.0002H35.7502C34.5076 16.0002 33.5002 14.9929 33.5002 13.7502C33.5002 12.5076 34.5076 11.5002 35.7502 11.5002H36.0002M36.0002 20.5002H33.5002M36.0002 20.5002V22.5002M36.0002 11.5002H38.5002M36.0002 11.5002V9.50024"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  )
}

export default GivingMoneyIcon
